import type { IconName } from "@similarweb/icons";

import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";

export const PLATFORM_ICON_NAME: Readonly<Record<AppOperatingSystem, IconName>> = {
    android: "google-play-colored",
    ios: "apple-store-colored",
};
